/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.ts to modify the generation of this file.

const getConfig = (env: Record<string, any>) => ({
	sitecoreApiKey: env.SITECORE_API_KEY || "{D1BC08B1-51C4-47F3-AB6D-99C50000C800}",
	sitecoreApiHost: env.SITECORE_API_HOST || "https://backend.aramcolife.local",
	jssAppName: env.JSS_APP_NAME || "aramco-jss",
	connected: env.CONNECTED || false,
	defaultLanguage: env.DEFAULT_LANGUAGE || "en",
	projects:
	{
  "AramcoQafilah": {
    "projectName": "AramcoQafilah",
    "siteName": "aramcoqafilah"
  },
  "AramcoStadium": {
    "projectName": "AramcoStadium",
    "siteName": "aramcostadium"
  },
  "AramcoTech": {
    "projectName": "AramcoTech",
    "siteName": "aramcotech"
  },
  "AramcoWorld": {
    "projectName": "AramcoWorld",
    "siteName": "aramcoworld"
  },
  "Raceteq": {
    "projectName": "Raceteq",
    "siteName": "raceteq"
  }
},
	devProject: { projectName: undefined, siteName: undefined },

});

export type SitecoreConfig = Omit<ReturnType<typeof getConfig>, "projects"> & { projects: Record<string, { projectName: string | undefined; siteName: string | undefined; }> };
export default getConfig as (env: Record<string, any>) => SitecoreConfig;